import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const UserAvatar = ({user, isNoUrl = false}) => {
	const handleAvatarUrl = () => {
		if (!isNoUrl) window.location.replace(user.view_url);
	}

	if (user && user.username) {
		return (
			<div onClick={handleAvatarUrl} className="cursor-pointer inline-flex items-center justify-center user-avatar w-full h-full rounded-full bg-primary">
				{user.avatar_urls.m ? (
					<LazyLoadImage src={user.avatar_urls.m} className="w-full h-full rounded-full" alt={user.username}/>
				) : (
					<span className="text-url font-semibold">{user.username.substring(0, 1)}</span>
				)}
			</div>
		)
	}
}

export default UserAvatar;